export const API_ENDPOINT = (() =>
{
    switch (process.env.REACT_APP_STAGE)
    {
        case "test":
            return "http://10.45.1.20:32578/api";
        case "prod":
            return process.env.REACT_APP_API_URL ?? "http://10.45.1.20:32578/api";
        default:
            return "http://localhost:4002/api";
    }
})();
